import { ManualNotifications } from '../../views/Settings/ManualNotifications';

export function NotificationsPage() {
  return <ManualNotifications />;
}
